import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-monthly-deductions',
    name: 'pay-monthly-deduction',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-monthly-deduction')
  }
]
